'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { OptimizedImage } from '@/components/images/optimized-image';
import { useOutcomeColor } from '@/hooks/chart/use-outcome-color';
import { SettledSeal } from './settled-seal';
interface WinnerIdentityHeaderProps {
  marketPubkey: string;
  outcomeIndex: number;
  name: string;
  imageUrl: string | null;
  imageNsfw: boolean;
  imageAlt: string;
  status: ReactNode;
  showSettledBadge?: boolean;
}

/** Shared winning-token identity for the trade card and Winner tab. */
export function WinnerIdentityHeader(t0) {
  const $ = _c(25);
  const {
    marketPubkey,
    outcomeIndex,
    name,
    imageUrl,
    imageNsfw,
    imageAlt,
    status,
    showSettledBadge: t1
  } = t0;
  const showSettledBadge = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== name || $[1] !== outcomeIndex) {
    t2 = {
      title: name,
      index: outcomeIndex
    };
    $[0] = name;
    $[1] = outcomeIndex;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const {
    hue
  } = useOutcomeColor(t2);
  const t3 = imageUrl !== null && imageUrl !== "" ? imageUrl : null;
  let t4;
  if ($[3] !== hue || $[4] !== imageNsfw || $[5] !== marketPubkey || $[6] !== outcomeIndex || $[7] !== t3) {
    t4 = {
      kind: "outcome",
      marketPubkey,
      outcomeIndex,
      hue,
      imageUrl: t3,
      nsfw: imageNsfw
    };
    $[3] = hue;
    $[4] = imageNsfw;
    $[5] = marketPubkey;
    $[6] = outcomeIndex;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== imageAlt || $[10] !== t4) {
    t5 = <OptimizedImage variant="thumbnail" entity={t4} alt={imageAlt} size="size-14" rounded="rounded-control" preview={false} />;
    $[9] = imageAlt;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== showSettledBadge) {
    t6 = showSettledBadge && <SettledSeal className="pointer-events-none absolute -bottom-2.5 -right-2.5 z-10 size-9" />;
    $[12] = showSettledBadge;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <div className="relative shrink-0">{t5}{t6}</div>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== name) {
    t8 = <span className="truncate text-heading text-foreground-primary">{name}</span>;
    $[17] = name;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== status || $[20] !== t8) {
    t9 = <div className="flex min-w-0 flex-col gap-1">{t8}{status}</div>;
    $[19] = status;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t7 || $[23] !== t9) {
    t10 = <div className="flex items-center gap-4">{t7}{t9}</div>;
    $[22] = t7;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  return t10;
}